import {useEffect, useState} from "react";
import {useAppSelector} from "../../../../../../redux/hooks";
import {
  getMySongsPageSongSelectedSongDetailsLessonArrangementTypeById,
  getMySongsPageSongSelectedSongDetailsLessonDifficultyCategoryById,
  getMySongsPageSongSelectedSongDetailsLessonDifficultySubcategoryById,
  getMySongsPageSongSelectedSongDetailsLessonPreviewsById
} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";
import {capitalizeFirstLetter} from "../../../../../../util/string-util";
import {ISongDetailsResponseSongLessonPreviews} from "../../../../../../client/models/songs/ISongDetailsResponse";
import {mySongsPageStore,} from "../../../../modules/my-songs-page-store/mySongsPage.store";
import {useSongDetailsDisplaySelectedLesson} from "../../hooks/useSongDetailsDisplaySelectedLesson";

export interface ISongDetailsLessonDetailsLogic {
  lessonId: number;
  lessonTitle: string;
  previews: Partial<ISongDetailsResponseSongLessonPreviews>;
  showPreviewSheetMusicModalHandler: () => void;
  showPreviewVideoModalHandler: () => void;
  wistiaThumbImgUrl?: string;
}

export const useSongDetailsLessonDetailsLogic = (): ISongDetailsLessonDetailsLogic => {
  const {lessonId: routerLessonId, firstLessonId} = useSongDetailsDisplaySelectedLesson();

  const activeLessonId = routerLessonId ?? firstLessonId ?? 0;

  const difficultyCategory  = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonDifficultyCategoryById(store, activeLessonId)) ?? ``;
  const difficultySubcategory  = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonDifficultySubcategoryById(store, activeLessonId)) ?? ``;
  const arrangementType  = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonArrangementTypeById(store, activeLessonId)) ?? ``;
  const previews  = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonPreviewsById(store, activeLessonId));

  const [wistiaThumbImgUrl, setWistiaThumbUrl] = useState<string>('');

  useEffect(() => {
    setWistiaThumbUrl('');
    if (!previews.wistiaVideoId) {
      // No Wistia video id, return to exit
      return;
    }
    fetch(`https://fast.wistia.net/oembed?url=https://home.wistia.com/medias/${previews.wistiaVideoId}?embedType=async&videoWidth=720`)
      .then(response => response.json())
      .then(data => setWistiaThumbUrl(data.thumbnail_url));
  }, [previews.wistiaVideoId,]);

  const lessonTitle = `${capitalizeFirstLetter(difficultyCategory)} ${capitalizeFirstLetter(difficultySubcategory)} ${capitalizeFirstLetter(arrangementType)}`;

  return {
    lessonId: activeLessonId,
    lessonTitle,
    previews,
    showPreviewSheetMusicModalHandler: () => mySongsPageStore.setSongDetailsPreviewModalContent(`sheetMusic`),
    showPreviewVideoModalHandler: () => mySongsPageStore.setSongDetailsPreviewModalContent(`video`),
    wistiaThumbImgUrl,
  };
}